import { render, staticRenderFns } from "./province-sales.vue?vue&type=template&id=b206a424&scoped=true"
import script from "./province-sales.vue?vue&type=script&lang=js"
export * from "./province-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b206a424",
  null
  
)

export default component.exports